import type {HelpFile} from '../../types/help'
import {ConditionsEditorTestIds} from '../../../testids/ConditionsEditorTestIds'

export const conditionsEditorHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [ConditionsEditorTestIds.btnAddCondition]:
            'Fügt eine Zeile aus Feld / Operator / Wert hinzu. Jede Kombination aus Feld und Operator kann nur einmal verwendet werden.',
        [ConditionsEditorTestIds.conditionsEmptyInfo]: null,
        [ConditionsEditorTestIds.conditionsEmptyHint]: null,
    },
}
